import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  Container,
  Col,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  Nav,
  NavItem,
} from "reactstrap";
import { useDispatch } from "react-redux";
import {
  addUserByRole,
  getRolesAdmin,
  getRolesForTables,
} from "../../slices/admin/thunk";
import {
  addOwnRoleNational,
  downloadEmployersReport,
  getOwnRoleNational,
} from "../../slices/national/thunk";
import Loading from "../../Components/Loading";
import classnames from "classnames";
import Swal from "sweetalert2";
import EmployerGroupsTable from "../../Components/Tables/EmployerGroupTable/EmployerGroupTable";
import { useCurrentUser } from "../../slices/auth/hooks";
import { DASHBOARD_USER_ROLES } from "../../constants";
import AddRoleModal from "../../Components/modals/GeneralModals/AddRoleModal";
import SearchBar from "../../Components/SearchBar/SearchBar";
import ButtonAddRole from "../../Components/Buttons/ButtonAddRole";
import HeadersRole from "../../Components/Headers/HeadersRole";
import employerIcon from "../../assets/images/iconsRoles/employerGroupIcon.svg";
import DownloadReportCSVButton from "../../Components/Buttons/DownloadReportCSVButton";
import DropdownActionsTable from "../../Components/Dropdown/DropdownActionsTable";
const DashboardNationalsEmployerGroups = () => {
  const currentUser = useCurrentUser();
  const inputRef = useRef(null);

  const [loading, setLoading] = useState(false);

  const [modalAddEmployerGroups, setModalAddEmployerGroups] = useState(false);

  const dispatch = useDispatch();

  const [employers, setEmployers] = useState([]);
  const [totalEmployers, setTotalEmployers] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [activeTab, setActiveTab] = useState("1");
  const [ownEmployers, setOwnEmployers] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  const handleToggleModal = () => {
    setModalAddEmployerGroups(!modalAddEmployerGroups);
  };

  const toggleTab = (tab, status) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setOwnEmployers(status === "own");
      setCurrentPage(0);
    }
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fecthRolesNationals = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRolesForTables({
          id: currentUser.id,
          userRole: "nationals",
          role: "employers",
          status: "active",
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setEmployers(response.data);
      setTotalEmployers(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const fetchOwnEmployers = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getOwnRoleNational({
          id: currentUser.id,
          role: "employers",
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setEmployers(response.data);
      setTotalEmployers(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    if (activeTab == "1") {
      fecthRolesNationals();
    } else {
      fetchOwnEmployers();
    }
  }, [currentPage, debouncedSearchTerm, dispatch, activeTab, ownEmployers]);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const handleAddEmployerGroup = async (data) => {
    try {
      setLoading(true);
      const response = await dispatch(
        addOwnRoleNational({
          id: currentUser.id,
          role: "employers",
          data,
        })
      ).unwrap();
      if (response.error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.error,
        });
        setLoading(false);
        return;
      } else {
        Swal.fire({
          icon: "success",
          title: "Employer Group added successfully",
          text: "Employer Group has been added successfully",
        });

        console.log(response);
        setLoading(false);
        setActiveTab("2");
        setModalAddEmployerGroups(false);
        fetchOwnEmployers();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",

        title: "Error",
        text: "Error adding employer group",
      });

      setLoading(false);
      console.log(error);
    }
  };

  return (
    <React.Fragment>
      <AddRoleModal
        open={modalAddEmployerGroups}
        setOpen={setModalAddEmployerGroups}
        onCreate={handleAddEmployerGroup}
        loading={loading}
        roleToAdd="Employer Groups"
      />
      <div className="page-content px-0 ">
        <Container fluid>
          <HeadersRole
            role={"Employer Groups"}
            icon={employerIcon}
            svg={true}
          />
          <Card className="mb-4 pb-3 ">
            <CardBody>
              <div className="col-12 d-flex justify-content-between mt-1  align-items-center ">
                <div className="col-4 d-flex justify-content-end align-items-center">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Filter by name or email"
                  />

                  <DropdownActionsTable
                    downloadMethod={downloadEmployersReport}
                    params={{ nationalId: currentUser.id }}
                  />
                </div>
              </div>

              <Col xl={12}>
                <div className="d-flex align-items-start justify-content-between mb-3">
                  <Nav
                    className="nav-tabs-custom p-2 mb-2 card-header-tabs border-bottom-0 mt-0 "
                    role="tablist"
                  >
                    <NavItem disabled={loading} className="me-3">
                      <NavLink
                        className={classnames(
                          {
                            "active  p-2 text-primary": activeTab === "1",
                            "fw-semibold": activeTab === "1",
                          },
                          {
                            "border-bottom border-2 border-primary":
                              activeTab === "1",
                          },
                          { " p-2 text-primary": activeTab !== "1" },
                          { disabled: loading }
                        )}
                        onClick={(e) => {
                          if (!loading) {
                            toggleTab("1", "all");
                          } else {
                            e.preventDefault();
                          }
                        }}
                        href="#"
                      >
                        ALL
                      </NavLink>
                      <NavLink
                        className={classnames(
                          {
                            "active  p-2 text-primary": activeTab === "2",
                            "fw-semibold": activeTab === "2",
                          },
                          {
                            "border-bottom border-2 border-primary":
                              activeTab === "2",
                          },
                          { " p-2 text-primary": activeTab !== "2" },
                          { disabled: loading }
                        )}
                        onClick={(e) => {
                          if (!loading) {
                            toggleTab("2", "own");
                          } else {
                            e.preventDefault();
                          }
                        }}
                        href="#"
                      >
                        MY EMPLOYER GROUPS
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <div className="col-4 d-flex justify-content-end align-items-center">
                    <ButtonAddRole
                      open={handleToggleModal}
                      roleToAdd="Employer Group"
                    />

                    {/* <DownloadReportCSVButton
                      downloadMethod={downloadEmployersReport}
                      params={{ nationalId: currentUser.id }}
                    /> */}
                  </div>
                </div>
                <div className="table-container  position-relative">
                  {loading && <Loading />}
                  <div className="live-preview">
                    <div className="table-responsive ">
                      <EmployerGroupsTable
                        data={employers}
                        searchDone={searchDone}
                        searchParam={debouncedSearchTerm}
                        paginationProps={{
                          itemsCount: employers.length,
                          totalPages: totalPages,
                          totalItems: totalEmployers,
                          currentPage: currentPage,
                          onChangePage: handleChangePage,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardNationalsEmployerGroups;
